import React, { Component } from "react";
import { Button, Modal, Divider } from "antd";
import "./index.less";
import { SvgIcon } from "../../../../components/common";
import {
  dataFormatterMMDDYYYY,
  isObjectNotEmpty,
} from "../../../../common/utils";

class TransferredSuccessfully extends Component {
  handleCancel = () => {
    if (this.props.closeConfirmPopup) {
      this.props.closeConfirmPopup();
    }
  };

  render() {
    const { itemsTransferDetails } = this.props;

    return (
      <Modal
        title="Transferred Successfully"
        className="transferred-successfully-model"
        centered
        open={true}
        onOk={this.handleCancel}
        onCancel={this.handleCancel}
        footer={null}
        closeIcon={<SvgIcon name="close" viewbox="0 0 13.426 13.423" />}
        maskClosable={false}
      >
        <div className="success-wrapper">
          <div className="success-upper">
            {/* Loop through locations */}
            {Object.keys(itemsTransferDetails).map((code) => (
              <div key={code} className="card">
                {/* Display items for each location */}
                {itemsTransferDetails[code].items.map((item) => (
                  <div key={item.item_code}>
                    <div className="card-header">
                      <div className="header-col">
                        <label>Item #</label>
                        <p>{item.item_code}</p>
                      </div>
                      <div className="header-col">
                        <label>Item Name</label>
                        <p>{item.item_name}</p>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="locations-list">
                        {/* "From" Locations */}
                        <div className="locations-row">
                          <div className="colum1">
                            <h4 className="items-title">Aisle Locations (From)</h4>
                          </div>
                          <div className="colum2">
                            <h4 className="items-title">Total Quantity</h4>
                          </div>
                          <div className="colum3">
                            <h4 className="items-title">Transferred</h4>
                          </div>
                        </div>
                        <div className="location-list-scroll">
                          <div className="locations-row">
                            <div className="colum1">
                              <h5>{item.location_code}</h5>
                              {isObjectNotEmpty(item.expiry_date) && (
                                <p>
                                  Expiring on{" "}
                                  {dataFormatterMMDDYYYY(item.expiry_date)}
                                </p>
                              )}
                            </div>
                            <div className="colum2">
                              <h5>{Number(item.on_hand_qty)}</h5>
                            </div>
                            <div className="colum3">
                              <h5>
                                {item.selectedDestinationLocations.reduce(
                                  (sum, data) => sum + data.transferQty,
                                  0
                                )}
                              </h5>
                            </div>
                          </div>
                        </div>
                        <Divider>
                          <div className="divider-arrow">
                            <SvgIcon name="arrow-down2" viewbox="0 0 9 15" />
                          </div>
                        </Divider>
                        {/* "To" Locations */}
                        <div className="locations-list">
                          <div className="locations-row">
                            <div className="colum1">
                              <h4 className="items-title">Aisle Locations (To)</h4>
                            </div>
                            <div className="colum2">
                              <h4 className="items-title">Quantity</h4>
                            </div>
                          </div>
                          {item.selectedDestinationLocations.map((data) => (
                            <div
                              key={data.destinationLocationId}
                              className="locations-row"
                            >
                              <div className="colum1">
                                <h5>{data.destinationLocationCode}</h5>
                              </div>
                              <div className="colum2">
                                <h5>{data.transferQty}</h5>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
          <div className="success-footer">
            <Button type="primary" block onClick={this.handleCancel}>
              TRANSFER another item
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}

export default TransferredSuccessfully;

